import { Handshake, Heart, Users, Calendar, GraduationCap, Globe } from "lucide-react";

const PARTNERS = [
  { icon: Handshake, t: "Co-engineering", d: "Joint reference architectures, shared roadmaps and deep integration of the Wiwi twin into your pipeline." },
  { icon: Globe, t: "Cloud & platform alliances", d: "First-class, certified deploys on your Kubernetes platform or managed cloud." },
  { icon: GraduationCap, t: "Enablement", d: "Hands-on training and certification so your teams get the most from the engine." },
  { icon: Users, t: "Reseller & revenue share", d: "Referral and reseller programs with transparent, recurring revenue share." },
];

const DIVERSITY = [
  { icon: Heart, t: "Belonging first", d: "Psychological safety, sponsorship and mentorship for everyone on the team." },
  { icon: Calendar, t: "Regular social events", d: "We connect often — with each other, and directly with our customers." },
  { icon: Users, t: "Equitable, bias-aware hiring", d: "Skills-based recruiting and inclusive interview practices." },
];

export const Partnership = () => (
  <section id="partnership" className="py-24 px-4 sm:px-6 lg:px-8 bg-background">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-start">
      <div>
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">Partnership</span>
        <h2 className="mt-3 font-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">
          Grow with us as a technology partner
        </h2>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Studios, engine vendors, cloud providers and agencies: integrate the Wiwi digital twin into your workflow and co-build the future of game backends. We invest in long-term relationships, shared wins and open collaboration.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {PARTNERS.map((p) => (
            <div key={p.t} className="flex gap-3" data-testid={`partnership-item-${p.t}`}>
              <p.icon className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
              <div>
                <h4 className="text-slate-100 font-medium text-sm">{p.t}</h4>
                <p className="text-sm text-slate-500 mt-0.5 leading-relaxed">{p.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div id="diversity" className="glass rounded-2xl border border-slate-800 p-8 shadow-2xl shadow-black/40">
        <span className="text-xs font-mono uppercase tracking-widest text-cyan-400">Diversity &amp; Inclusion</span>
        <h3 className="mt-3 font-display text-2xl font-semibold text-slate-100">Built by a team as diverse as its players</h3>
        <p className="mt-3 text-slate-400 leading-relaxed text-sm">
          Games are played by everyone, so they should be built by everyone. We foster a positive, collaborative culture where every voice shapes the product — because different backgrounds build better systems, and better games.
        </p>
        <div className="mt-6 grid grid-cols-3 gap-3 text-center">
          {[["30+", "nationalities welcome"], ["50%", "mentorship coverage"], ["100%", "pay-equity reviewed"]].map(([a, b]) => (
            <div key={a} className="rounded-lg border border-slate-800 bg-slate-950/50 p-3">
              <div className="font-display text-xl font-bold text-cyan-400">{a}</div>
              <div className="text-[10px] text-slate-500 font-mono mt-1 leading-tight">{b}</div>
            </div>
          ))}
        </div>
        <div className="mt-6 space-y-4">
          {DIVERSITY.map((d) => (
            <div key={d.t} className="flex gap-3" data-testid={`diversity-item-${d.t}`}>
              <div className="w-9 h-9 rounded-lg bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center shrink-0">
                <d.icon className="w-4 h-4 text-cyan-400" />
              </div>
              <div>
                <h4 className="text-slate-100 font-medium text-sm">{d.t}</h4>
                <p className="text-sm text-slate-500 mt-0.5">{d.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
